import type { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

const LEAD_SCORING_BASE_KEY = "lead-scoring";
const SCORING_CONFIG_KEY = "scoring-config";
const LEAD_SCORING_AGENT_QUERY_KEY = "lead-scoring-agent";

type LeadScoringAgentQueryKey = {
    all: () => readonly string[];
    allSummaries: () => readonly string[];
    summary: (domain: string, score: string, triggeredRuleId: string) => readonly string[];
    allConfigs: () => readonly string[];
    config: (configType: ScoringConfigType) => readonly string[];
    configUpdate: () => readonly string[];
};

export const leadScoringAgentQueryKeys: LeadScoringAgentQueryKey = {
    all() {
        return [LEAD_SCORING_BASE_KEY] as const;
    },

    allSummaries() {
        return [...leadScoringAgentQueryKeys.all(), LEAD_SCORING_AGENT_QUERY_KEY] as const;
    },
    summary(domain: string, score: string, triggeredRuleId: string) {
        return [...leadScoringAgentQueryKeys.allSummaries(), domain, score, triggeredRuleId] as const;
    },

    allConfigs() {
        return [...leadScoringAgentQueryKeys.all(), SCORING_CONFIG_KEY] as const;
    },

    config(configType: ScoringConfigType) {
        return [...leadScoringAgentQueryKeys.allConfigs(), configType] as const;
    },

    configUpdate() {
        return [...leadScoringAgentQueryKeys.allConfigs(), "update"] as const;
    },
};
